// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0088a9b0","488":"a23c9d10"}[chunkId] + ".chunk.js";
};